<template>
  <div id="question-library">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" v-if="true">
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('contentManagement.quaestionLibrary.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.questionlibrary.filter.searchTerm != '' && $store.state.questionlibrary.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateFormId = null;
                modalVisible = true;
              "
              >{{ $t("contentManagement.quaestionLibrary.addQuestion") }}</el-button
            >
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.quaestionLibrary.filter") }}</h5>
                <span>{{ $t("contentManagement.quaestionLibrary.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.questionlibrary.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.questionlibrary.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.faq.title") }}</h5>
              <span v-if="$store.state.questionlibrary.items.length > 0" v-html="$t('totalContent', [$store.state.questionlibrary.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="false">
          <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.questionlibrary.items.length > 0">
            <div class="custom-grid-table-header question-library-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <div>{{ $t("contentManagement.quaestionLibrary.question") }}</div>
              <div>{{ $t("contentManagement.quaestionLibrary.view") }}</div>
            </div>
            <draggable :list="$store.state.questionlibrary.items" tag="div" handle=".el-icon-s-grid" class="list-group-o question-table-container" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
              <div class="item" v-for="item in $store.state.questionlibrary.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="cont-1">
                  <div class="table-icon">
                    <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                  </div>
                  <div class="question-item-title" @click="item.show = !item.show">{{ item.title }} <i class="collapse-btn-quest-icon el-icon-arrow-down" :class="{ active: item.show }"></i></div>
                  <div><el-switch v-model="item.isActive" @change="toggleItem(item.id)"></el-switch></div>
                  <div class="action-btns">
                    <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                      <el-button
                        type="primary"
                        icon="fas fa-pen"
                        circle
                        size="mini"
                        @click="
                          updateFormId = item.id;
                          modalVisible = true;
                        "
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                      <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
                <el-collapse-transition>
                  <div class="question-item-desc" v-show="item.show == true" v-html="item.details"></div>
                </el-collapse-transition>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-faq-lottie'"
              :title="$t('event.menu.faq.title')"
              @btnAdd="
                updateFormId = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
      <!-- <div class="content faq-content mt-3" v-else>
        <lottie-player autoplay loop mode="normal" src="/static/js/holacon-faq-lottie.json" style="width: 220px"> </lottie-player>
        
      </div> -->
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateFormId ? $t('contentManagement.quaestionLibrary.editQuestion') : $t('contentManagement.quaestionLibrary.addQuestion')" class="medium" center append-to-body destroy-on-close>
      <QuestionLibraryAddOrUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" v-if="modalVisible" :id="updateFormId" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import QuestionLibraryAddOrUpdate from "../../components/QuestionLibraryAddOrUpdate";
import draggable from "vuedraggable";
import $ from "jquery";
export default {
 metaInfo() {
    return {
      title: this.$t("eventPageTitle.faq")
    };
  },
  components: { PageCountInfo, QuestionLibraryAddOrUpdate, draggable },
  name: "QuestionLibrary",
  data() {
    return {
      questionShort: null,
      dragList: false,
      modalVisible: false,
      updateFormId: null,
      isFilterEnabled: false,
      timeout: null,
      loading: false,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary"
    };
  },
  methods: {
    async changeSort() {
      if (this.questionShort != null) clearTimeout(this.questionShort);
      this.loading = "loadingList";
      this.questionShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.questionlibrary.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveQuestionsOrders", payload);
        await this.$store.dispatch("getQuestionLibrary");
        this.loading = false;
      }, 500);
    },
    async refreshList() {
      if (this.questionShort != null) clearTimeout(this.questionShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getQuestionLibrary");
      this.questionShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    handleSizeChange(take) {
      this.$store.commit("setQuestionLibraryTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setQuestionLibraryPage", page);
    },
    itemUpdated(item) {
      var index = this.$store.state.questionlibrary.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.questionlibrary.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getQuestionLibrary");
    },
    async deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteQuestionLibrary", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getQuestionLibrary");
        }
      }, 500);
    },
    confirmItem(index) {
      this.$store.dispatch("confirmQuestionLibrary", { index, context: this });
    },
    cancelItem(index) {
      this.$store.dispatch("cancelQuestionLibrary", { index, context: this });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("toggleQuestionLibrary", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    }
  },

  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getQuestionLibrary");
      this.loading = false;
    }, 500);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.questionlibrary.filter.page - 1) * this.$store.state.questionlibrary.filter.take;
    },
    take() {
      return this.skip + this.$store.state.questionlibrary.items.length;
    }
  },
  watch: {
    "$store.state.questionlibrary.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getQuestionLibrary");
      }, 500);
    }
  }
};
</script>
<style lang="less">
.faq-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.question-library-grid-template {
  grid-template-columns: 36px 1fr 90px 90px;
}
.question-table-container {
  display: flex;
  flex-direction: column;

  .item {
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    & > .action-btns {
      display: flex;
      flex-direction: row;
      gap: 0.3rem;
      .el-button {
        margin: 0;
      }
    }

    &.passive {
      background-color: #fff2f2 !important;
    }
    .cont-1 {
      display: grid;
      grid-template-columns: 36px 1fr 90px 90px;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;

      .question-item-title {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        line-height: normal;
        cursor: pointer;

        i {
          margin-left: 6px;
        }
      }

      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
        &.me {
          color: #ccc;
        }
      }
      & > .title {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > i.el-icon-loading {
          font-size: 20px;
        }
      }

      & > div:last-child {
        justify-self: flex-end;
      }
    }

    .question-item-desc {
      padding: 16px 44px;

      p {
        font-size: 13px;
        display: block;
        font-weight: 500;
        color: #505763;
        line-height: normal;
        padding: unset;
        margin: unset;
      }
    }

    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.loading-list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  i {
    font-size: 20px;
    color: blueviolet;
    font-weight: bold;
  }
}
.collapse-btn-quest-icon {
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.5s;
  &.active {
    transform: rotate(-180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/QuestionLibrary.vue